import { render, staticRenderFns } from "./KPIItemGrid.vue?vue&type=template&id=c930674e"
import script from "./KPIItemGrid.vue?vue&type=script&lang=js"
export * from "./KPIItemGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports